// necessary dependencies //
import { React } from 'react';
import { Link } from 'react-router-dom';
import Fade from 'react-reveal/Fade';
// css //
import styles from './Header.module.scss';
// images //
import { Ellipse } from '../../images/icons/Ellipse'
import { Star } from '../../images/icons/Star'

const Header = () => {
  
  return (
    <>
        <div className={`${styles.header_wrapper} container`} >
            <Fade cascade>
            <div className={styles.header_details}>
                <div className={styles.header_button}>
                    <button>fira.</button>
                </div>
                <div className={styles.header_info}>
                    <h2>Coding Experience <br/> Crafted Patiently</h2>
                    <Ellipse className={styles.ellipse}/>
                </div>
                {/* <div className={styles.burger}>
                    <span className={styles.line1}></span>
                    <span className={styles.line2}></span>
                    <span className={styles.line3}></span>
                </div> */}
                {/* <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} /> */}
                <div className={styles.header_about}>
                    <div className={styles.header_jump}>
                        <Star className={styles.star}/>
                        <h2>Jump to</h2>
                    </div>
                    <ul>
                        <li>
                            <a onClick={() => window.location.replace("/#aboutme")}>About</a>
                        </li>
                        <li><a onClick={() => window.location.replace("/#works")}>Works</a></li>
                        <li><a onClick={() => window.location.replace("/#contact")}>Contact</a></li>
                        {/* <li><a href="https://drive.google.com/file/d/1r4pTCAHRFKOEjgGjNJZXZVGYFxTw5-OR/view?usp=sharing" target="_blank" rel="noopener noreferrer">Resume</a></li> */}
                    </ul>
                </div>
            </div>
            </Fade>
        </div>
        {/* <div className={styles.header_container}>
            <div className={styles.blocks}>
                    <div className={styles.block}></div>
                    <div className={styles.block}></div>
                    <div className={styles.block}></div>
            </div>
            <div className={styles.header_container_details}>
                <div className={styles.header_container_points}>
                    <ul>
                        <li><a>Fira's</a></li>
                        {/* <li><a>Contact Me</a></li> */}
                    {/* </ul>
                </div>
            </div>
        </div> */}
    </>
  );
};

export default Header;
